import dayjs from 'dayjs';

export class DateUtils {
    private static readonly SHORT_DATE_FORMAT = 'DD.MM.YYYY';

    public static toShortDate(date: string): string {
        return dayjs(date).format(DateUtils.SHORT_DATE_FORMAT);
    }
}
